import { z } from 'zod'
import { tagSchema } from './tags'

const baseDashboardSchema = z.object({
  id: z.string(),
  title: z.string(),
  last_landscape_analysis_id: z.string(),
  source_id: z.string(),
  parent_source_id: z.string(),
  source_type: z.enum([
    'search_query',
    'filter',
    'dashboard',
    'monitor',
    'patent_list',
  ]),
  is_patent_list: z.boolean(),
})

export const dashboardListEntrySchema = baseDashboardSchema.extend({
  patents_count: z.number().int().nonnegative(),
})

export type DashboardListEntry = z.infer<typeof dashboardListEntrySchema>

// This also has family_id and publication_date, but we do not need them, and if we will, we should
// rather fetch up to date data from the indexer directly.
export const visualizeSinglePatentInput = z.object({
  document_number: z.string(),
})

export const dashboardSchema = baseDashboardSchema.extend({
  patents: z.array(visualizeSinglePatentInput),
})

export type Dashboard = z.infer<typeof dashboardSchema>

export const apiDashboardMutationResponseSchema = z.object({
  message: z.string(),
  data: dashboardSchema.pick({ id: true, last_landscape_analysis_id: true }),
})

export const taggedDashboardListSchema = dashboardListEntrySchema.extend({
  tags: tagSchema.array(),
})

export type TaggedDashboardList = z.infer<typeof taggedDashboardListSchema>
